<template>
  <v-dialog persistent v-model="roleAssetDialog" width="520" content-class="ec-dialog">
    <v-form v-model="form" ref="newAssetForm" lazy-validation :disabled="loading">

      <!-- ── Header ──────────────────────────────────────────────────────── -->
      <div class="ec-dialog__header">
        <h3 class="ec-dialog__title">New Asset</h3>
        <button class="ec-icon-btn" type="button" @click="closeNewAsset">
          <v-icon size="18">mdi-close</v-icon>
        </button>
      </div>

      <!-- ── Body ───────────────────────────────────────────────────────── -->
      <div class="ec-dialog__body">
        <div class="ec-row">
          <div class="ec-field--half">
            <label class="ec-label">Name *</label>
            <v-text-field
              v-model="assetRole.name"
              :rules="[rules.required]"
              placeholder="e.g. Licence Assets"
              outlined dense hide-details="auto"
            />
          </div>
          <div class="ec-field--half">
            <label class="ec-label">Asset Type *</label>
            <v-text-field
              v-model="assetRole.url"
              :rules="[rules.required, rules.assetType]"
              placeholder="LicenceAssetsController"
              outlined dense hide-details="auto"
            />
            <p class="ec-hint">PascalCase format — defines access context</p>
          </div>
        </div>

        <div class="ec-field">
          <label class="ec-label">Scope Type</label>
          <v-select
            v-model="assetRole.scopeType"
            :items="scopes"
            item-text="name"
            item-value="scope"
            placeholder="Select scope"
            outlined dense hide-details
            clearable
          />
        </div>

        <v-checkbox
          v-model="assetRole.bindSuperAdmin"
          label="Bind to Superadmin Role"
          dense hide-details
          class="mt-1"
        />
      </div>

      <!-- ── Footer ─────────────────────────────────────────────────────── -->
      <div class="ec-dialog__footer">
        <button class="ec-btn ec-btn--ghost" type="button" @click="closeNewAsset">Cancel</button>
        <button
          class="ec-btn ec-btn--primary"
          type="button"
          :disabled="!form || loading"
          @click="saveAsset"
        >
          <v-progress-circular v-if="loading" size="13" width="2" indeterminate style="margin-right:6px" />
          Save Asset
        </button>
      </div>

    </v-form>
  </v-dialog>
</template>

<script>
import { ROLE_ASSETS_ENDPOINT } from '@/service/backend_endpoints/_endpointPaths'
import { apiService } from '../../service/api.service'
import Swal from 'sweetalert2'
import { mapGetters } from 'vuex'

export default {
  props: {
    roleAssetDialog: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters(['getLicenceScopes', 'loadingSubScopes'])
  },
  data () {
    return {
      form: true,
      loading: false,
      scopes: [],
      assetRole: { name: '', url: '', scopeType: true, bindSuperAdmin: true },
      rules: {
        required: (v) => !!v || 'This field is required',
        assetType: (v) => /^[A-Z][a-zA-Z0-9]*$/.test(v) || 'Asset type must be in PascalCase'
      }
    }
  },
  async created () {
    await this.$store.dispatch('getLicenceScopes')
    this.scopes = this.getLicenceScopes.map((s) => ({ name: s.name, scope: s.scope }))
  },
  methods: {
    closeNewAsset () { this.$emit('closeRoleAssetDialog') },
    async saveAsset () {
      if (!this.$refs.newAssetForm.validate()) return
      this.loading = true
      const payload = {
        name: this.assetRole.name,
        url: this.assetRole.url,
        scopeType: this.assetRole.scopeType,
        bindSuperAdmin: this.assetRole.bindSuperAdmin
      }
      await apiService.post(ROLE_ASSETS_ENDPOINT, payload)
        .then(() => {
          this.$emit('fetchAssets')
          this.closeNewAsset()
          Swal.fire({ icon: 'success', title: 'Success', text: 'Asset created successfully' })
        })
        .catch((err) => {
          Swal.fire({ icon: 'error', title: 'Error', text: err.response?.data?.message || 'Failed to create asset' })
        })
        .finally(() => { this.loading = false })
    }
  }
}
</script>
